import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Page from 'components/widgets/Route';
import * as actions from './actions';
import ConfigurationList from './container/ConfigurationList';
import ConfigurationEditor from './container/ConfigurationEditor';

class ConfigurationRoute extends React.Component {
	constructor(props) {
		super(props);
		this.fetchConfig = this.fetchConfig.bind(this);
		this.listConfigs = this.listConfigs.bind(this);
	}

	fetchConfig({ match: { params } }) {
		this.props.actions.fetchConfig(encodeURIComponent(params.name));
	}

	listConfigs() {
		this.props.actions.listConfigs();
	}

	render() {
		const { match: { path }, hasNav } = this.props;
		return (
			<Page>
				<Page.Route
					exact
					path={path}
					onEnter={this.listConfigs}
					component={ConfigurationList}
				/>
				<Page.Route
					hasNav={hasNav}
					exact
					path={`${path}/:name`}
					onEnter={this.fetchConfig}
					component={ConfigurationEditor}
				/>
			</Page>
		);
	}
}

ConfigurationRoute.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		hasNav: state.config.error && !state.config.saving
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ConfigurationRoute);

